import { TWarboxConversationInitialState } from '../types';

export const DEFAULT_WARBOX_CONVERSATION_STATE: TWarboxConversationInitialState = {
    conversation: null,
    conversations: null,
    total: 0,
    loading: false,
    error: null,
    success: null,
};
